import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { HStack, Icon, Link, VStack } from '..';
import colors from '../../theme/foundations/colors';
export var MobileOptionsAccordion = _ref => {
  var {
    children
  } = _ref;
  var [isExpanded, setIsExpanded] = useState(false);
  return /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    cursor: "pointer",
    my: 3,
    py: 3,
    px: 6,
    borderTop: "1px solid ".concat(colors.blue[300]),
    borderBottom: "1px solid ".concat(colors.blue[300]),
    width: "100%",
    onClick: () => setIsExpanded(e => !e)
  }, /*#__PURE__*/React.createElement(Link, null, "Search options"), /*#__PURE__*/React.createElement(Icon, {
    fontSize: "lg",
    color: colors.blue[400]
  }, isExpanded ? /*#__PURE__*/React.createElement(FaChevronUp, null) : /*#__PURE__*/React.createElement(FaChevronDown, null))), isExpanded ? children : null);
};